import type { ComponentProps } from 'react';
import { Link, useLocation } from 'react-router';
import { ROUTES } from '../lib/constants';
import { guideLinkState } from '../lib/guide-navigation';

type GuideLinkProps = Omit<ComponentProps<typeof Link>, 'to' | 'state'> & { chapter?: string };

export default function GuideLink({ chapter, ...props }: GuideLinkProps) {
  const location = useLocation();
  return <Link {...props} to={`${ROUTES.GUIDE}${chapter ? `#${chapter}` : ''}`} state={guideLinkState(location)} />;
}
